/**
 * JKL Featured Collections JavaScript
 * Migrated from: shopify-headless/app/components/featuredCollection/FeaturedCollectionList.tsx
 * 
 * Initializes Swiper carousel for featured collections.
 * Breakpoints match Hydrogen implementation:
 * - Mobile (0-767px): 1.1 slides per view
 * - Tablet (768-1023px): 2 slides per view
 * - Desktop (1024px+): 3 slides per view
 */

import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

/**
 * Initialize Featured Collections Swiper
 */
function initFeaturedCollections() {
  const swiperContainers = document.querySelectorAll('.jkl-featured-collections__swiper');
  
  swiperContainers.forEach((container) => {
    const collectionsCount = parseInt(container.dataset.collectionsCount, 10) || 0;
    
    // Only initialize Swiper if we have more than 1 item
    if (collectionsCount <= 1) {
      // For single item, just display without Swiper functionality
      container.classList.add('jkl-featured-collections__swiper--single');
      return;
    }
    
    // Initialize Swiper with Hydrogen-matching breakpoints
    const swiper = new Swiper(container, {
      // Match Hydrogen: slidesPerView: 1 (base)
      slidesPerView: 1.1,
      spaceBetween: 16,
      
      // Breakpoints matching Hydrogen Carousel component
      breakpoints: {
        // Mobile: 1.1 slides per view (shows peek of next slide)
        // spaceBetween creates gap between slides like Hydrogen's mx-4
        0: {
          slidesPerView: 1.1,
          spaceBetween: 0,
        },
        // Tablet: 2 slides per view
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        // Desktop: 3 slides per view
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
      
      // Pagination
      pagination: {
        el: container.querySelector('.jkl-featured-collections__pagination'),
        clickable: true,
        type: 'bullets',
      },
      
      // Smooth transitions
      speed: 400,
      
      // Allow touch/swipe
      grabCursor: true,
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous collection',
        nextSlideMessage: 'Next collection',
        paginationBulletMessage: 'Go to collection {{index}}',
      },
    });
    
    // Store swiper instance on container for potential external access
    container.swiperInstance = swiper;
  });
}

/**
 * Initialize on DOM ready
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedCollections);
} else {
  // DOM already loaded
  initFeaturedCollections();
}

/**
 * Re-initialize on Shopify section load (Theme Editor)
 */
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.jkl-featured-collections__swiper')) {
    initFeaturedCollections();
  }
});

/**
 * Handle section unload - destroy Swiper instances
 */
document.addEventListener('shopify:section:unload', (event) => {
  const container = event.target.querySelector('.jkl-featured-collections__swiper');
  if (container && container.swiperInstance) {
    container.swiperInstance.destroy(true, true);
  }
});
